export default "__VITE_ASSET__1117eb66__"